import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: null,       // 用户认证 token
    nickname: null,    // 用户昵称
	user_id:""
  },
  mutations: {
    // 更新 token
    SET_TOKEN(state, token) {
      state.token = token;
	  localStorage.setItem('token', token); // 持久化
    },
    // 更新 nickname
    SET_NICKNAME(state, nickname) {
      state.nickname = nickname;
	  localStorage.setItem('nickname', nickname); // 持久化
    },
	SET_USERID(state, user_id) {
	  state.user_id = user_id;
	  localStorage.setItem('user_id', user_id); // 持久化
	},
	 // 初始化时从 localStorage 加载
	 INITIALIZE_STORE(state) {
	    state.token = localStorage.getItem('token');
	    state.nickname = localStorage.getItem('nickname');
		state.user_id = localStorage.getItem('user_id');
	  },
    // 清空用户信息（退出登录时使用）
    CLEAR_USER(state) {
      state.token = null;
      state.nickname = null;
	  state.user_id = "";
	  
	  localStorage.removeItem('token');
	  localStorage.removeItem('nickname');
	  localStorage.removeItem('user_id');
	  localStorage.removeItem('redirectPath');
	 
	  
    },
  },
  actions: {
    // 模拟登录操作（实际项目中替换为 API 调用）
    login({ commit }, { token, nickname,user_id }) {
      //return new Promise((resolve) => {
        // 模拟异步登录
        //setTimeout(() => {
          commit('SET_TOKEN', token);
          commit('SET_NICKNAME', nickname);
		  commit('SET_USERID', user_id);
          //resolve();
        //}, 500);
      //});
    },
    // 退出登录
    logout({ commit }) {
      commit('CLEAR_USER');
    },
	
  },
  getters: {
    // 获取当前登录状态
    isLoggedIn: (state) => !!state.token,
    // 获取用户昵称（如果未登录返回默认值）
    userNickname: (state) => state.nickname || '',
  },
});